(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name core.controller:cardWidget
     *
     * @description
     *
     */
    angular
        .module('core')
        .directive('cardWidget', cardWidget);

    function cardWidget() {
        return {
            restrict: 'E',
            scope: {
                card: '='
            },
            templateUrl: 'cards/shared/card-widget/card-widget.tpl.html',
            replace: false,
            controllerAs: 'vm',
            controller: function ($scope) {

                this.formatCardNumber = function (cn) {
                    return cn.replace(/(.{4})/g, '$1 ').trim()
                };
        
            }
        };
    }
}());